import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useState } from 'react'
import { Outlet } from 'react-router'
import { useIsIFramed, useKeyBindings, useResource } from '../../../hooks'

interface ContainerProps {
  isIFramed?: boolean
}

const applyMarginIfNotIFramed = ({ isIFramed }: ContainerProps) =>
  isIFramed
    ? ''
    : `
      margin: 1rem;
      width: calc(100% - 2rem);
    `

const Container = styled('div')`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  place-self: start;
  ${applyMarginIfNotIFramed}
`

const Index = () => {
  const isIFramed = useIsIFramed()
  const { resource } = useResource()
  const [isTimeZoneVisible, beTimeZoneVisible] = useState(false)

  useKeyBindings({
    't z': () => beTimeZoneVisible(!isTimeZoneVisible),
  })

  return (
    <Container isIFramed={isIFramed}>
      {!isIFramed && (
        <Typography variant="h1">
          {resource?.name}
          {isTimeZoneVisible && <span>&nbsp;({resource?.timezone})</span>}
        </Typography>
      )}
      <Outlet />
    </Container>
  )
}

export { Index }
